import React from "react";
import { Component } from "react";
import { Button } from "react-bootstrap";
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import { ControlSelect, ControlText, ControlTextarea } from "../../../../common/custom-form/control-field.component";
import { CustomDropdown } from "../../../../common/custom-form/custom-dropdown.component";
import CustomSearchableSelectWrapper from "../../../../common/custom-form/custom-searchable-select-wrapper.component";
import { inventoryCircuitEquipActions } from "../../../../../store/external/reports-reducer/inventory/details-view/add-equipment.reducer";
import { ACTION_TYPES, Selected_Index, EQUIPMENT_TYPE, MAX_LENGTH, DATA_TYPE } from "../../../../../constants/external-constants";
import { InputFieldFloatingLabel as InputField } from "../../../../common/custom-form/select-filter.component";
import Translation from "../../../../../components/common/translation/translation.component";
import { ConfirmationNotificationModal } from "../../../../common/modal/confirmation-modal.component";
import { NotificationModal } from "../../../../common/modal/notification-modal.component";
import TableWithButton from "../../../../common/details-table/table-with-button.component";
import { assignDefaultIfEmptyString, hasObjectWithProperty } from "../../../../../utils/helpers.utils";

class AddEquipment extends Component {
    constructor(props) {
        super(props);
        this.state = {
            updateEquipDetails: false,
            activeDropdown: false,
            showDetails: false,
            showModal: false,
            showNotif: false,
            notifTitle: null,
            tableLength: 0,
        }
    }

    componentDidMount() {
        const { circuitId, vendorId, getCircuitEquipList } = this.props;
        getCircuitEquipList(circuitId, vendorId).then(() =>{
        const { circuitEquipList } = this.props.inventoryCircuitEquip;
        const tableLength = circuitEquipList?.datatable[0]?.dataItem?.length;
            this.setState({tableLength})
        });
      
    }
    componentDidUpdate(prevProps) {
        const { circuitId, vendorId, getCircuitEquipList } = this.props;
        if (this.props.vendorId !== prevProps.vendorId) {
            getCircuitEquipList(circuitId, vendorId).then(() =>{});;
        }
    }

    componentWillUnmount() {
        const { resetCircuitEquipForm, resetCircuitEquipDetails } = this.props;
        resetCircuitEquipForm();
        resetCircuitEquipDetails();
    }

    showDetails(value) {
        this.setState({
            showDetails: value
        });
    }

    onClickCancel = () => {
        const { resetCircuitEquipForm } = this.props;
        this.toggleActiveState();
        resetCircuitEquipForm();

        this.setState({
            updateEquipDetails: false
        });
    }

    onRowClick = (index) => {
        const { viewCircuitEquipItem } = this.props;
        this.toggleActiveState();
        viewCircuitEquipItem(index);

        this.setState({
            updateEquipDetails: true
        });
    }

    updateCircuitEquip = () => {
        const { updateCircuitEquipItem, resetCircuitEquipForm, toggleDropdown } = this.props;

        updateCircuitEquipItem();
        toggleDropdown(Selected_Index.i_Six);
        resetCircuitEquipForm();
        this.toggleActiveState(false);

        this.setState({
            updateEquipDetails: false,
            notifTitle: 'updated'
        });
    }

    addCircuitEquip = () => {
        const { addCircuitEquipItem, resetCircuitEquipForm, toggleDropdown } = this.props;
     
        addCircuitEquipItem();
        toggleDropdown(Selected_Index.i_Six);
        resetCircuitEquipForm();
        this.toggleActiveState(false);
    }
    onClickAdd = () =>{

        this.setState({
            showModal: true,
            notifTitle: 'added'
        })

    }

    toggleActiveState = () => {
        this.setState(prevState => ({ activeDropdown: !prevState.activeDropdown }));
    }

    handleConfirmationModal = (buttonType) =>{
        if(buttonType === "ok"){
            this.state.updateEquipDetails ? this.updateCircuitEquip() : this.addCircuitEquip()
            this.props.handleChangesStatus('equipmentChange', true)
            this.setState( prev => ({
                showModal: false,
                showNotif: false
            }))
        }else{
            this.setState({
                showModal: false
            });
        }        
    }
    handleCloseNotif = () =>{
        this.setState({showNotif:false});
    }

    handleOpenNotif = () =>{
        this.setState({
            showNotif: true,
            notifTitle: 'deleted'
        });
    }
      
    isUpdateButtonEnabled = (state, form, circuitList) => {
        // Extract relevant properties from the objects
        const {
          updateEquipDetails
        } = state;
        const {
          TypeId,
          ModelId,
          IMEISerialNumber,
          StatusId,
          Price,
          ID,
          AssetTagNumber,
          ProductName,
          PartCode,
          AdditionalInformation
        } = form;
        const dataItem = circuitList.datatable[0].dataItem[ID];
        
        if (updateEquipDetails) {
            const isIMEIRequired = (parseInt(TypeId) === parseInt(EQUIPMENT_TYPE.Device)) ? IMEISerialNumber : true;
            const isFormValid =
                TypeId && ModelId && isIMEIRequired && StatusId && Price;

          const hasChanged =
            Number(dataItem?.TypeId) !== Number(TypeId) ||
            Number(dataItem?.ModelId) !== Number(ModelId) ||
            Number(dataItem?.StatusId) !== Number(StatusId) ||
            dataItem?.IMEISerialNumber !== IMEISerialNumber ||
            dataItem?.AssetTagNumber !==  assignDefaultIfEmptyString(AssetTagNumber, null) ||
            dataItem?.ProductName !== ProductName ||
            dataItem?.PartCode !== assignDefaultIfEmptyString(PartCode, null) ||
            dataItem?.Price !== Price ||
            dataItem?.AdditionalInformation !== assignDefaultIfEmptyString(AdditionalInformation, null);
      
          return isFormValid && hasChanged;
        }
      
        return false;
    }

    deleteCircuitEquipItem = (index) =>{
        const {deleteCircuitEquipItem, handleChangesStatus} = this.props;
        const { circuitEquipList } = this.props.inventoryCircuitEquip;

        deleteCircuitEquipItem(index);

        const updatedCircuitEquipList = circuitEquipList;

        let newTable = updatedCircuitEquipList?.datatable[0]?.dataItem;

        newTable.splice(index, 1); 

        handleChangesStatus('equipmentChange', true)
        

        const containsObjectWithID = hasObjectWithProperty(newTable, "ID", -1);

            if(containsObjectWithID || this.state.tableLength !== newTable.length){
                handleChangesStatus('equipmentChange', true)
            }else{
                handleChangesStatus('equipmentChange', false)

            }
    }

    render() {
        const {inventoryCircuitEquipForm, onServiceModelSelect, translator, hasPendingApproval } = this.props;
        const { circuitEquipList, equipTypes, equipDevices, equipAccessories, equipStatuses } = this.props.inventoryCircuitEquip;
        const isDevice = inventoryCircuitEquipForm.TypeId === EQUIPMENT_TYPE.Device ? true : false;
        const isIMEIRequired = isDevice ? inventoryCircuitEquipForm.IMEISerialNumber : true;
        const enableAddBtn = inventoryCircuitEquipForm.TypeId && inventoryCircuitEquipForm.ModelId && isIMEIRequired && inventoryCircuitEquipForm.StatusId && inventoryCircuitEquipForm.Price;

        return (
            <>
                <NotificationModal 
                    show={this.state.showNotif} 
                    title={'Success'} 
                    message={`Sim circuit ${this.state.notifTitle} successfully!`}
                    handleModal={this.handleCloseNotif}
                    customClass={'comment-notification-modal notification-footer'}
                 />
                <CustomDropdown activeDropdown={this.state.activeDropdown} toggleActiveState={this.toggleActiveState} label={<Translation translationKey="add_equipment" />}>
                    <div className={`add-equipment-container detail-page-container details-4-col-container`}>
                        <ControlSelect label={<Translation translationKey="equipment_type" />} options={equipTypes} model="inventoryCircuitEquipForm.TypeId" isRequired={true} value={inventoryCircuitEquipForm.TypeId} placeholder={`${translator("select_placeholder")}`} />
                        <CustomSearchableSelectWrapper
                            label={<Translation translationKey="model_upper" />}
                            options={parseInt(inventoryCircuitEquipForm.TypeId) === parseInt(EQUIPMENT_TYPE.Device) ? equipDevices : (parseInt(inventoryCircuitEquipForm.TypeId) === parseInt(EQUIPMENT_TYPE.Accessory) ? equipAccessories : [])}
                            selected={inventoryCircuitEquipForm.ModelId}
                            onChange={(e) => onServiceModelSelect('inventoryCircuitEquipForm.ModelId', e)}
                            requiredField={true}
                            placeholder={`${translator("select_placeholder")}`}
                            fieldProp='inventoryCircuitEquipForm.ModelId'
                            isMainFilter={true}
                            optionLabelKey={{
                                Key: 'FilterId',
                                Value: 'FilterName',
                                Label: 'FilterName'
                            }}
                            maxLength={MAX_LENGTH.limit_100}
                            disabled={false}
                        />
                        <ControlText label={<Translation translationKey="imei_serial_no_upper" />} model="inventoryCircuitEquipForm.IMEISerialNumber" isRequired={isDevice} value={inventoryCircuitEquipForm.IMEISerialNumber} placeholder={`${translator("enter_text_placeholder")}`} maxLength={100} />
                        <ControlText label={<Translation translationKey="asset_tag_num_upper" />} model="inventoryCircuitEquipForm.AssetTagNumber" value={inventoryCircuitEquipForm.AssetTagNumber} placeholder={`${translator("enter_text_placeholder")}`} maxLength={100} />
                        <ControlSelect label={<Translation translationKey="status" />} options={equipStatuses} model="inventoryCircuitEquipForm.StatusId" isRequired={true} value={inventoryCircuitEquipForm.StatusId} placeholder={`${translator("select_placeholder")}`} />
                        <ControlText label={<Translation translationKey="product_name" />} model="inventoryCircuitEquipForm.ProductName" value={inventoryCircuitEquipForm.ProductName} placeholder={`${translator("enter_text_placeholder")}`} maxLength={100} />
                        <ControlText label={<Translation translationKey="part_code" />} model="inventoryCircuitEquipForm.PartCode" value={inventoryCircuitEquipForm.PartCode} placeholder={`${translator("enter_text_placeholder")}`} maxLength={100} />
                        <InputField
                            className="form-control required"
                            type="text"
                            label={<Translation translationKey="price_upper" />}
                            value={inventoryCircuitEquipForm.Price}
                            fieldProp='inventoryCircuitEquipForm.Price'
                            inputType={DATA_TYPE.decimal}
                            maxLength={MAX_LENGTH.inputText} />
                        <ControlTextarea label={<Translation translationKey="additional_information" />} model="inventoryCircuitEquipForm.AdditionalInformation" colClassName="details-container-full-row" value={inventoryCircuitEquipForm.AdditionalInformation} placeholder={`${translator("enter_text_placeholder")}`} maxLength={255} />

                        <div className="add-button-container custom-add-button">
                            <div className="btn-tooltiptext">
                                <Button onClick={this.onClickCancel} className="btn-custom-violet-hover-outline">Cancel</Button>
                                <span className="tooltip-text">{this.state.updateEquipDetails ? <Translation translationKey="cancel_update_equipment_details" /> : <Translation translationKey="cancel_add_equipment_details" />}</span>
                            </div>                           
                                <ConfirmationNotificationModal 
                                    show={this.state.showModal} 
                                    message={this.state.updateEquipDetails ? 'Are you sure you want to update?' : 'Are you sure you want to add?'} 
                                    title={this.state.updateEquipDetails ? 'Update' : 'Add'}
                                    handleModal={this.handleConfirmationModal}
                                    customClass={'comment-notification-modal modal-text-bold'}
                                />

                                <div className={'btn-tooltiptext'}>
                                    <Button 
                                        className="btn-add"
                                        disabled={(this.props.isReadOnly || this.props.isReadAndExtractOnly) ? true : hasPendingApproval ? hasPendingApproval :
                                            (this.state.updateEquipDetails ? !this.isUpdateButtonEnabled(this.state, inventoryCircuitEquipForm, circuitEquipList) : !enableAddBtn)} 
                                        onClick={this.onClickAdd}>{`${this.state.updateEquipDetails? ACTION_TYPES.Update : ACTION_TYPES.Add}`}
                                    </Button>
                                <span className="tooltip-text">{this.state.updateEquipDetails ? <Translation translationKey="update_equipment_details" /> : <Translation translationKey="add_equipment_details" /> }</span>
                                </div>
                        </div>
                    </div>
                </CustomDropdown>
                {circuitEquipList.datatable.length > 0 && circuitEquipList.datatable[0].dataItem.length > 0 &&
                    <div className="details-table-container add-equipment-container">
                        <TableWithButton
                                classNameWrapper="table-details-wrapper table-clickable"
                                datatable={circuitEquipList.datatable}
                                haveExternalDeleteBtn={this.props.IsReadOnly ? false : (this.props.isReadAndExtractOnly ? false : (this.props.isReadAndWrite ? true : false))}
                                deleteAction={(index) => this.deleteCircuitEquipItem(index)}
                                rowClickAction={this.onRowClick}
                                handleOpenNotif={this.handleOpenNotif}
                        />  
                    </div>
                }
            </>
        )
    }
}

export default connect(
    state => {
        const { inventoryCircuitEquip } = state;
        const { inventoryCircuitEquipForm } = state.form;
        return {
            inventoryCircuitEquip
            , inventoryCircuitEquipForm
        };
    },
    dispatch => bindActionCreators(
        Object.assign({}, inventoryCircuitEquipActions),
        dispatch
    )
)(AddEquipment);